// Top level "pack" file for webpack.
//
// This is for specifying what should be compiled as part of the main asset bundle.
//
// Examples:
//   * JS written in a rails view or partial
//   * JS written in published content such as articles
//
// The separate ./server.js file should be used for any JS required to perform server
// side rendering.
import '../legacy_imports.js';
import { setupAnalytics } from '../application/javascripts/analytics_util.js';

setupAnalytics();

// rails UJS is required for the "unobtrusive javascript" behavior that augments
// a variety of behaviors in a rails app.
var railsUJS = require('@rails/ujs');
railsUJS.start();
